// @flow
import UAParser from 'ua-parser-js';

// Based on stastboard logging, we have identified some browsers where keepalive does not work as expected.
export const keepaliveIsKnownToBeBuggy = (
  { name, version }: { name: string, version: string },
  whitelistSafari13?: boolean,
) => {
  const majorVersion = parseInt(version.replace(/\..*/, ''), 10) || 0;
  switch (name.toLowerCase()) {
    case 'chrome':
      return majorVersion > 0 && majorVersion < 74;
    case 'safari':
      return !whitelistSafari13 && majorVersion >= 13; // TODO: keepalive works until version 13. figure out why.
    default:
      return false;
  }
};

// https://github.com/github/fetch/issues/700#issuecomment-484523384
export const keepaliveIsSupported = (whitelistSafari13: boolean) =>
  'keepalive' in new Request('') &&
  !keepaliveIsKnownToBeBuggy(new UAParser().getBrowser(), whitelistSafari13);
